import React, { Component } from 'react';
import { navigateTo } from 'common/util';
import "./index.less";

const wx = window.wx || {};

export default class Finish extends Component {


    checkPoundBill = ()=>{
        const { pkDelivery, pkOrg } = this.props;
        let getUrl = currentPage => {
            currentPage = currentPage || ''
            return `/downloadPoundBill${currentPage}?deliveryId=${pkDelivery}&stockorgId=${pkOrg}`
        }
        navigateTo({
            path: getUrl(),
            url: `/pages${getUrl('/index')}`,
        })
        console.log(wx);
        // wx.miniProgram.navigateTo({url:`../share/index?deliveryId=${pkDelivery}&stockorgId=${pkOrg}`});
    }

    render() {
        return (
            <div className="finish-bottom">
                <button onClick={this.checkPoundBill}>查看磅单</button>
            </div>
        )
    }
}
